import { render } from "./cancel_appointment.vue?vue&type=template&id=31c1a6ef&scoped=true"
import script from "./cancel_appointment.vue?vue&type=script&lang=js"
export * from "./cancel_appointment.vue?vue&type=script&lang=js"

import "./cancel_appointment.vue?vue&type=style&index=0&id=31c1a6ef&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31c1a6ef"]])

export default __exports__